// ---------------------------------------------------------------------------
// Legend — how to read the tally marks. Static bilingual (CSS toggles en/ne).
// ---------------------------------------------------------------------------
import React from "react";

function Legend() {
    return (
        <div className="legend">
            <span className="lg">
                <span className="box" style={{background: "var(--emerald-soft)", borderColor: "#BFE0CF"}}>
                    <i style={{background: "var(--emerald)"}} /><i style={{background: "var(--emerald)"}} />
                </span>
                <span className="en">Rang on time</span><span className="ne">समयमै बज्यो</span>
            </span>
            <span className="lg">
                <span className="box" style={{background: "var(--gold-soft)", borderColor: "#EFD79E"}}>
                    <i style={{background: "var(--gold)"}} /><i style={{background: "var(--gold)"}} />
                </span>
                <span className="en">Rang late</span><span className="ne">ढिलो बज्यो</span>
            </span>
            <span className="lg">
                <span className="box" style={{background: "var(--fail-soft)", borderColor: "#EFC7C1"}}>
                    <i style={{border: "1.5px solid var(--fail)"}} /><i style={{border: "1.5px solid var(--fail)"}} />
                </span>
                <span className="en">Did not ring</span><span className="ne">बजेन</span>
            </span>
            <span className="lg">
                <span className="box" style={{background: "repeating-linear-gradient(135deg,#F5F7FA 0 4px,#E7EBF2 4px 8px)"}}>
                    <i style={{border: "1.5px solid var(--offline)"}} /><i style={{border: "1.5px solid var(--offline)"}} />
                </span>
                <span className="en">Device offline</span><span className="ne">यन्त्र अफलाइन</span>
            </span>
            <span className="lg">
                <span className="box">
                    <i style={{border: "1.5px dashed #C9D3E2"}} /><i style={{border: "1.5px dashed #C9D3E2"}} />
                </span>
                <span className="en">Scheduled</span><span className="ne">तालिकामा</span>
            </span>
            <span className="hint">
                <span className="en">Each mark is one strike — Period 3 rings three times.</span>
                <span className="ne">प्रत्येक धर्को एक प्रहार — तेस्रो पिरियडमा तीन पटक बज्छ।</span>
            </span>
        </div>
    );
}

export default Legend;
